import { render, staticRenderFns } from "./AppStatusBadge.vue?vue&type=template&id=0b2753cf&scoped=true&"
import script from "./AppStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AppStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AppStatusBadge.vue?vue&type=style&index=0&id=0b2753cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2753cf",
  null
  
)

export default component.exports